import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 解决导航栏或者底部导航tabBar中的vue-router在3.0版本以上频繁点击菜单报错的问题。
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}


const routes = [
  {
    path: '/',
    name: 'Manager',
    component: () => import('../views/Manager.vue'),
    redirect: '/home',
    children: [
      { path: '403', name: 'NoAuth', meta: { name: '无权限', noTags: true }, component: () => import('../views/manager/403') },
      { path: 'home', name: 'Home', meta: { name: '系统首页' }, component: () => import('../views/manager/Home') },
      { path: 'admin', name: 'Admin', meta: { name: '管理员信息' }, component: () => import('../views/manager/Admin') },
      { path: 'permission', name: 'Permission', meta: { name: '权限管理' }, component: () => import('../views/manager/Permission') },
      { path: 'adminPerson', name: 'AdminPerson', meta: { name: '个人信息' }, component: () => import('../views/manager/AdminPerson') },
      { path: 'password', name: 'Password', meta: { name: '修改密码' }, component: () => import('../views/manager/Password') },
      { path: 'notice', name: 'Notice', meta: { name: '公告管理' }, component: () => import('../views/manager/Notice') },
      { path: 'frontNav', name: 'FrontNav', meta: { name: '导航栏' }, component: () => import('../views/manager/FrontNav') },
      { path: 'industryNewsCategory', name: 'IndustryNewsCategory', meta: { name: '二级目录' }, component: () => import('../views/manager/IndustryNewsCategory') },
      { path: 'industryNewsArticle', name: 'IndustryNewsArticle', meta: { name: '新闻设置' }, component: () => import('../views/manager/IndustryNewsArticle') },
      { path: 'contentAnalysis', name: 'ContentAnalysis', meta: { name: '内容分析' }, component: () => import('../views/manager/ContentAnalysis') },
      { path: 'trafficAnalysis', name: 'TrafficAnalysis', meta: { name: '流量分析' }, component: () => import('../views/manager/TrafficAnalysis') },
      { path: 'weiChat', name: 'MpRevenue', meta: { name: '公众号收益' }, component: () => import('../views/manager/MpRevenue') },
      { path: 'category', name: 'Category', meta: { name: '文章分类' }, component: () => import('../views/manager/Category') },
      { path: 'user', name: 'User', meta: { name: '用户信息' }, component: () => import('../views/manager/User') },
      { path: 'site', name: 'Site', meta: { name: '站点管理' }, component: () => import('../views/manager/Site') },
      { path: 'authCode', name: 'AuthCodeGenerator', meta: { name: '授权码生成器' }, component: () => import('../views/manager/AuthCodeGenerator') },
      { path: 'aiLayoutAuth', name: 'AiLayoutAuth', meta: { name: 'AI排版授权码' }, component: () => import('../views/manager/AiLayoutAuth') },
      { path: 'mockMnsj', name: 'MockMnsj', meta: { name: '模拟数据' }, component: () => import('../views/manager/MockMnsj') },
      { path: 'article', name: 'Article', meta: { name: '文章管理' }, component: () => import('../views/manager/Article') },
      { path: 'articleSyncLog', name: 'ArticleSyncLog', meta: { name: '同步日志' }, component: () => import('../views/manager/ArticleSyncLog') },
      { path: 'articleOperateStats', name: 'ArticleOperateStats', meta: { name: '运营文章统计报表' }, component: () => import('../views/manager/ArticleOperateStats') },
      { path: 'operateWarning', name: 'OperateWarning', meta: { name: '运营预警表' }, component: () => import('../views/manager/OperateWarning') },
      { path: 'imageTextCategory', name: 'ImageTextCategory', meta: { name: '图文分类' }, component: () => import('../views/manager/ImageTextCategory') },
      { path: 'imageText', name: 'ImageText', meta: { name: '图文管理' }, component: () => import('../views/manager/ImageText') },
      { path: 'mpRevenueStats', name: 'MpRevenueStats', meta: { name: '收益统计表' }, component: () => import('../views/manager/MpRevenueStats') },
      { path: 'mnsjMpRevenueReport', name: 'MnsjMpRevenueReport', meta: { name: '公众号收益报表' }, component: () => import('../views/manager/MnsjMpRevenueReport') },
      { path: 'revenueDetail', name: 'RevenueDetail', meta: { name: '流量主明细' }, component: () => import('../views/manager/RevenueDetail') },
      { path: 'revenueDetailStats', name: 'RevenueDetailStats', meta: { name: '流量主统计' }, component: () => import('../views/manager/RevenueDetailStats') },
      { path: 'mnsjMpRevenue', name: 'MnsjMpRevenue', meta: { name: '公众号流量主收益' }, component: () => import('../views/manager/MnsjMpRevenue') },
      { path: 'WechatBind', name: 'WechatBind', meta: { name: '绑定微信公众号' }, component: () => import('../views/manager/WechatBind') },
    ]
  },
  {
    path: '/front',
    name: 'Front',
    component: () => import('../views/Front.vue'),
    children: [
      { path: 'home', name: 'Home', meta: { name: '系统首页' }, component: () => import('../views/front/Home') }
    ]
  },
  { path: '/Login', name: 'Login', meta: { name: '登录' }, component: () => import('../views/Login') },
  { path: '/register', name: 'Register', meta: { name: '注册' }, component: () => import('../views/Register.vue') },
  { path: '*', name: 'NotFound', meta: { name: '无法访问', noTags: true }, component: () => import('../views/404.vue') },
  { path: '/logins', name: 'logins', meta: { name: '登录1' }, component: () => import('../views/logins.vue') },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫：前台主页由 nginx 在 / 提供静态页；/front/home 为历史路由需跳走
router.beforeEach((to, from, next) => {
  const user = JSON.parse(localStorage.getItem('xm-user') || '{}')
  const isAdmin = user.role && user.role !== 'USER'

  if (to.path === '/front/home') {
    // 历史路由：跳静态主页。不可 replace('/')，否则与旧 nginx「/ -> /front/home」死循环
    window.location.replace('/front-home.html')
    next(false)
    return
  }

  if (to.path === '/') {
    if (isAdmin) {
      next('/home')
    } else {
      window.location.replace('/')
      next(false)
    }
    return
  }

  next()
})

export default router
